import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/dist/locale/id";
import {
  Avatar,
  Col,
  ConfigProvider,
  Divider,
  Row,
  Flex,
  Card,
  Space,
  Image,
} from "antd";
import defaultImage from "../assets/images/png/general/img_thumb_default.png";
import defaultBadges from "../assets/images/png/general/img_thumb_badges.png";

import {
  backgroundCard,
  backgroundBodyExportProfile,
  backgroundDetailExportProfile,
  descTextExportProfile,
  titleTextExportProfile,
  colorUserPhotoExportProfile,
  textUserPhotoExportProfile,
  textTitleProfile,
  textDescProfile,
} from "../config/constant/color";
import { Loader } from "./Loader";
import { useDispatch, useSelector } from "react-redux";

// for translate
import { useTranslation } from "react-i18next";

const ProfilePDF = ({
  userData,
  detailUser,
  journey,
  achievements,
  certificate,
  disableExport,
  setDisableExport,
  additional,
}) => {
  const reRenderMenu = useSelector((state) => state.localization.reRenderMenu);
  const { t, i18n } = useTranslation();

  const localeDate = i18n.language === "en" ? "en" : "id";

  const [certifItem, setCertifItem] = useState([]);
  const [loadingExport, setLoadingExport] = useState(true);

  const setResponsiveHeightCertif = () => {
    let x = 1;
    let heightTemp = 0;
    let queryAll = [];

    if (certifItem.length != 0) {
      certifItem.map((item, index) => {
        let indexNode =
          document.querySelectorAll(".name-certif-card")[index].offsetHeight;

        if (indexNode > heightTemp) {
          heightTemp = indexNode;
        }

        if (x % 5 == 0 || x == certifItem.length) {
          queryAll.push(heightTemp);
          heightTemp = 0;
        }
        x++;
      });
      certificateElementModified(queryAll);
    }

    setLoadingExport(false);
  };

  const certificateElementModified = (queryAll) => {
    let x = 1;
    let indexArr = 0;
    let modifiedItems = [];
    certificate.map((item, idx) => {
      modifiedItems.push(
        <Card
          key={idx}
          style={{ width: "173px", border: "none" }}
          bodyStyle={{ padding: 0 }}
        >
          <Image
            preview={false}
            src={"data:image/png;base64," + item.file_name_base64}
            width={173}
            height={122}
            style={{ borderRadius: "12px" }}
            fallback={defaultImage}
            alt="Certificate"
          />

          <Space direction="vertical" style={{ width: "100%" }}>
            <div
              style={{
                fontWeight: "500",
                color: titleTextExportProfile,
                marginTop: "10px",
                marginBottom: "5px",
                minHeight: `${queryAll[indexArr]}px`,
              }}
            >
              {item.name_certif}
            </div>

            <div>
              <div
                style={{
                  color: descTextExportProfile,
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                {t("feature.feature_profile.sec_certi.earned_on")}{" "}
                <span
                  style={{ color: titleTextExportProfile, fontWeight: "500" }}
                >
                  {moment(item.recived)
                    .locale(localeDate)
                    .format("DD MMM YYYY")}
                </span>
              </div>
              <div
                style={{
                  color: descTextExportProfile,
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                {t(
                  "feature.feature_profile.sec_popup_completed_program.program",
                )}{" "}
                <span
                  style={{ color: titleTextExportProfile, fontWeight: "500" }}
                >
                  {item.journey_name}
                </span>
              </div>
            </div>
          </Space>
        </Card>,
      );

      if (x % 5 == 0 || x == certificate.length) {
        indexArr++;
      }
      x++;
    });

    setCertifItem([...modifiedItems]);
  };

  const certificateElementDefault = (certificate) => {
    const data = certificate.map((item, idx) => {
      return (
        <Card
          className="export-certif-card"
          key={idx}
          style={{ width: "173px", border: "none" }}
          bodyStyle={{ padding: 0 }}
        >
          <Image
            preview={false}
            src={"data:image/png;base64," + item.file_name_base64}
            width={173}
            height={122}
            style={{ borderRadius: "12px" }}
            fallback={defaultImage}
            alt="Certificate"
          />

          <Space direction="vertical" style={{ width: "100%" }}>
            <div
              className="name-certif-card"
              style={{
                fontWeight: "500",
                color: titleTextExportProfile,
                marginTop: "10px",
                marginBottom: "5px",
                minHeight: "10px",
              }}
            >
              {item.name_certif}
            </div>

            <div>
              <div
                style={{
                  color: descTextExportProfile,
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                {t("feature.feature_profile.sec_certi.earned_on")}{" "}
                <span
                  style={{ color: titleTextExportProfile, fontWeight: "500" }}
                >
                  {moment(item.recived)
                    .locale(localeDate)
                    .format("DD MMM YYYY")}
                </span>
              </div>
              <div
                style={{
                  color: descTextExportProfile,
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                {t(
                  "feature.feature_profile.sec_popup_completed_program.program",
                )}{" "}
                <span
                  style={{ color: titleTextExportProfile, fontWeight: "500" }}
                >
                  {item.journey_name}
                </span>
              </div>
            </div>
          </Space>
        </Card>
      );
    });

    setCertifItem([...data]);
  };

  useEffect(() => {
    setDisableExport(true);
    setLoadingExport(true);

    certificate.length > 0
      ? certificateElementDefault(certificate)
      : setDisableExport(false);
  }, [certificate, reRenderMenu]);

  useEffect(() => {
    certifItem.length == certificate.length
      ? loadingExport == false
        ? setDisableExport(false)
        : setResponsiveHeightCertif()
      : "";
  }, [certifItem, reRenderMenu]);

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Roboto",
            colorPrimaryActive: backgroundCard,
          },
        }}
      >
        <div
          style={{
            background: backgroundDetailExportProfile,
            padding: "80px 80px 40px",
          }}
        >
          <Row align={"middle"} justify={"space-between"}>
            <Col>
              <Row>
                <Col>
                  {detailUser.picture_base64 != "" &&
                  detailUser.picture_base64 != null ? (
                    // <div style={{borderRadius:'50%', backgroundImage:`url(data:image/png;base64,${detailUser.picture_base64})`, width:'78px', height:"78px", border:'none', backgroundSize:'cover', backgroundRepeat:'no-repeat', backgroundPosition:'center'}}></div>
                    <div
                      style={{
                        height: "78px",
                        width: "78px",
                        borderRadius: "50%",
                        position: "relative",
                        overflow: "hidden",
                        float: "left",
                      }}
                    >
                      <img
                        src={
                          "data:image/png;base64," + detailUser.picture_base64
                        }
                        style={{
                          top: "50%",
                          left: "50%",
                          position: "relative",
                          transform: "translate(-50%,-50%)",
                          height: "100%",
                          width: "auto",
                          maxWidth: "none",
                        }}
                      />
                    </div>
                  ) : (
                    <Avatar
                      size={78}
                      style={{
                        backgroundColor: colorUserPhotoExportProfile,
                        fontSize: "32px",
                        fontWeight: "500",
                        border: "none",
                        color: textUserPhotoExportProfile,
                      }}
                    >
                      {userData.firstname &&
                        Array.from(userData.firstname)[0].toUpperCase()}
                    </Avatar>
                  )}
                </Col>

                <Col style={{ marginLeft: "20px" }}>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: "500",
                      color: titleTextExportProfile,
                      marginBottom: "11px",
                    }}
                  >
                    {userData.userName}
                  </div>
                  <Row>
                    <Col style={{ marginRight: "20px" }}>
                      <div>{t("feature.feature_profile.header.role")}</div>
                      <div
                        style={{
                          color: titleTextExportProfile,
                          fontWeight: "500",
                        }}
                      >
                        {userData.userPosition == ""
                          ? "-"
                          : userData.userPosition}
                      </div>
                    </Col>

                    <Divider type="vertical" style={{ height: "auto" }} />

                    <Col style={{ margin: "0 20px" }}>
                      <div>{t("feature.feature_profile.header.username")}</div>
                      <div
                        style={{
                          color: titleTextExportProfile,
                          fontWeight: "500",
                        }}
                      >
                        {detailUser?.username || "-"}
                      </div>
                    </Col>

                    <Divider type="vertical" style={{ height: "auto" }} />

                    <Col style={{ margin: "0 20px" }}>
                      <div>
                        {t("feature.feature_profile.header.registered_on")}
                      </div>
                      <div
                        style={{
                          color: titleTextExportProfile,
                          fontWeight: "500",
                        }}
                      >
                        {detailUser?.created_at ? moment(detailUser.created_at)
                          .locale(localeDate)
                          .format("DD MMMM YYYY") : "-"}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div
          style={{
            background: backgroundBodyExportProfile,
            padding: "37px 80px 0",
          }}
        >
          {certificate.length > 0 ? (
            <div>
              <div
                style={{
                  color: titleTextExportProfile,
                  fontSize: "22px",
                  fontWeight: "500",
                }}
              >
                {t("feature.feature_profile.main_content.certificates")}
              </div>
              <Divider
                style={{
                  border: "1px solid " + titleTextExportProfile,
                  opacity: "24%",
                  marginTop: "15px",
                  marginBottom: "32px",
                }}
              />
              <Flex wrap="wrap" gap="50px 40px">
                {certifItem}
              </Flex>
            </div>
          ) : (
            ""
          )}
          {achievements.length > 0 ? (
            <div style={{ marginTop: "60px" }}>
              <div
                style={{
                  color: titleTextExportProfile,
                  fontSize: "22px",
                  fontWeight: "500",
                }}
              >
                {t("feature.feature_profile.main_content.badges")}
              </div>
              <Divider
                style={{
                  border: "1px solid " + titleTextExportProfile,
                  opacity: "24%",
                  marginTop: "15px",
                  marginBottom: "32px",
                }}
              />
              <Flex wrap="wrap" gap="50px 40px">
                {achievements.map((item, idx) => (
                  <Card
                    key={idx}
                    style={{
                      width: "173px",
                      height:300,
                      border: "none",
                      textAlign: "center",
                    }}
                    bodyStyle={{ padding: 0 }}
                  >
                    <Image
                      width={80}
                      height={80}
                      preview={false}
                      src={"data:image/png;base64," + item.logo_base64}
                      style={{ borderRadius: "50%" }}
                      fallback={defaultBadges}
                      alt="Badges"
                    />

                    <div
                      style={{
                        fontWeight: "500",
                        color: titleTextExportProfile,
                        marginTop: "10px",
                        marginBottom: "5px",
                      }}
                    >
                      {item.name}
                    </div>

                    <div>
                      <div
                        style={{
                          color: descTextExportProfile,
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {t("feature.feature_profile.sec_certi.earned_on")}{" "}
                        <span
                          style={{
                            fontWeight: "500",
                            color: titleTextExportProfile,
                          }}
                        >
                          {moment(item.created_at)
                            .locale(localeDate)
                            .format("DD MMM YYYY")}
                        </span>
                      </div>
                      <div
                        style={{
                          color: descTextExportProfile,
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {t("feature.feature_profile.sec_badges.from_badges")}{" "}
                        <span
                          style={{
                            fontWeight: "500",
                            color: titleTextExportProfile,
                          }}
                        >
                          {item.module}
                        </span>
                      </div>
                    </div>
                  </Card>
                ))}
              </Flex>
            </div>
          ) : (
            ""
          )}

          {journey.length > 0 ? (
            <div
              style={{
                marginTop:
                  certificate.length + achievements.length > 15 &&
                  journey.length > 5
                    ? "60px"
                    : "60px",
              }}
            >
              <div
                style={{
                  color: titleTextExportProfile,
                  fontSize: "22px",
                  fontWeight: "500",
                }}
              >
                {t("feature.feature_profile.main_content.completed_program")}
              </div>
              <Divider
                style={{
                  border: "1px solid " + titleTextExportProfile,
                  opacity: "24%",
                  marginTop: "15px",
                  marginBottom: "32px",
                }}
              />
              <Flex wrap="wrap" gap="50px 40px">
                {journey.map((item, idx) => (
                  <Card
                    key={idx}
                    style={{ border: "none", width: "173px" }}
                    bodyStyle={{ padding: 0 }}
                  >
                    {/* <div style={{borderRadius:'8px',backgroundImage:`url(data:image/png;base64,${item.thumbnail_base64})`, width:'173px', height:"123px", border:'none', backgroundSize:'cover', backgroundRepeat:'no-repeat', backgroundPosition:'center'}}></div> */}
                    <div
                      style={{
                        height: "123px",
                        width: "173px",
                        borderRadius: "12px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={"data:image/png;base64," + item.thumbnail_base64}
                        style={{
                          height: "100%",
                          width: "auto",
                          top: "50%",
                          left: "50%",
                          position: "relative",
                          transform: "translate(-50%,-50%)",
                          maxWidth: "none",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: titleTextExportProfile,
                        textAlign: "left",
                        marginTop: "10px",
                        marginBottom: "5px",
                        height: "40px",
                      }}
                    >
                      <div
                        className="break-dots-second-line"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </div>
                    </div>

                    <div
                      style={{
                        fontWeight: "400",
                        color: descTextExportProfile,
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "feature.feature_profile.sec_completed_program.completed_on",
                      )}{" "}
                      <span
                        style={{
                          color: titleTextExportProfile,
                          fontWeight: "500",
                        }}
                      >
                        {moment(item.completed_date)
                          .locale(localeDate)
                          .format("DD MMM YYYY")}
                      </span>
                    </div>
                  </Card>
                ))}
              </Flex>
            </div>
          ) : (
            ""
          )}

          {additional.length > 0 ? (
            <div style={{ marginTop: "60px" }}>
              <div
                style={{
                  color: titleTextExportProfile,
                  fontSize: "22px",
                  fontWeight: "500",
                }}
              >
                {t("feature.feature_tm.additional_learning")}
              </div>
              <Divider
                style={{
                  border: "1px solid " + titleTextExportProfile,
                  opacity: "24%",
                  marginTop: "15px",
                  marginBottom: "32px",
                }}
              />
              <Flex wrap="wrap" gap="50px 40px">
                {additional.map((item, idx) => (
                  <Card
                    key={idx}
                    style={{
                      width: "173px",
                      border: "none",
                      textAlign: "left",
                    }}
                    bodyStyle={{ padding: 0 }}
                  >
                    <Image
                      preview={false}
                      src={"data:image/png;base64," + item.thumbnail_base64}
                      width={173}
                      height={122}
                      style={{ borderRadius: "12px" }}
                      fallback={defaultImage}
                      alt="Additional Thumbnail"
                    />

                    <Space direction="vertical" style={{ width: "100%" }}>
                      <div
                        style={{
                          fontWeight: "500",
                          color: textTitleProfile,
                          marginTop: "10px",
                          marginBottom: "5px",
                          height: "40px",
                        }}
                      >
                        <div>{item.module_name}</div>
                      </div>

                      <div style={{ marginBottom: "5px" }}>
                        <div
                          style={{
                            color: textDescProfile,
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {t("feature.feature_tm.completed_on")}{" "}
                          <span
                            style={{
                              fontWeight: "500",
                              color: textTitleProfile,
                            }}
                          >
                            {moment(item.completed_date)
                              .locale(localeDate)
                              .format("DD MMM YYYY")}
                          </span>
                        </div>
                        <div
                          style={{
                            color: textDescProfile,
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {t("feature.feature_tm.from")}{" "}
                          <span
                            style={{
                              fontWeight: "500",
                              color: textTitleProfile,
                            }}
                          >
                            {item.journey_name}
                          </span>
                        </div>
                      </div>
                    </Space>
                  </Card>
                ))}
              </Flex>
            </div>
          ) : (
            ""
          )}
        </div>
      </ConfigProvider>
    </>
  );
};

export default ProfilePDF;
